import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
	selector: 'app-kamona-success-modal',
	templateUrl: './kamona-success-modal.component.html',
	styleUrls: ['./kamona-success-modal.component.scss']
})
export class KamonaSuccessModalComponent implements OnInit {
	@Output() closeModal = new EventEmitter();
	@Input() title: string;
	@Input() additionalResponses: any[];
	@Input() description: string;
	isCopied: boolean;
	@Input() useFullButton: boolean;
	@Input() btnText: string;

	constructor() {
	}

	ngOnInit(): void {

	}

	cancelModal() {
		this.closeModal.emit(true);
	}

	copyAdditionalInfo(item) {
		const textArea = document.createElement('textarea');
		textArea.value = item;
		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand('Copy');
		textArea?.remove();
		this.isCopied = true;
	}

	setCopied() {
		this.isCopied = false;
	}
}
